/* eslint-disable @typescript-eslint/no-shadow */
import { articoloBE, clienteBE } from 'src/app/models/sync.model';
import * as _ from 'lodash';
import * as moment from 'moment';
import { User } from './user.model';
import { contoDepositoInfo } from '../confing';
/* eslint-disable @typescript-eslint/naming-convention */
export interface cart {
  closed: boolean;
  cliente: string;
  cliente_intestazione: string;
  data: Date;
  righe: Array<cartItem>;
  modpag?: number;
  id?: string;
  dataresa?: number;
  orders?: Array<order>;
  riferimentocliente?: string | null;
  datariferimentocliente?: string | null;
  evasionedal?: string | null;
  evadibileintegralmente?: string | null;
  annotazionetesta?: string | null;
  asaldo?: string | null;
}

export interface cartItem {
  ean: string;
  article: articoloBE;
  qta: number;
  prezzo?: number;
  qtaOmaggio?: number;
  sconto?: number;
  contoDeposito?: boolean;
  qtaContoDeposito?: number;
  scontoCliente?: number;
}

export interface order {
  datiRord: datiOrder;
}

export interface ordineDaTrasmettere {
  datiRord: datiOrder;
  cart: cart;
  totale: number;
  omaggi: number;
  id: string;
  sended?: boolean;
  nr?: number;
  dataTrasmissione?: Date;
  error?: string;
}

export interface datiOrder {
  ditta: number;
  agente: number;
  cliente: number;
  magazzino: number;
  tipocarrello: string;
  dataordine: number;
  dataconsegna: null;
  dataresa: number | null;
  riferimentocliente: string | null;
  pagamento: number;
  numerorighe: number;
  elencoArticoli: Array<articoloOrder>;
  datariferimentocliente: number | null;
  evasionedal: number | null;
  evadibileintegralmente: string | null;
  annotazionetesta: string | null;
  saldoordine: string | null;
}

export interface articoloOrder {
  ean: number;
  qta: number;
  titolo: string;
  scontobase: null | number;
  sconto1: null | number;
  sconto2: null | number;
  sconto3: null | number;
  omaggio: string;
  scontoaggiuntivo: string;
  annotazione: null;
}

export class order implements order {
  constructor(cart: cart, righe: Array<cartItem>, tipo: string, agente: User) {
    const datiRord: any = {};

    datiRord.elencoArticoli = [];
    datiRord.cliente = Number(cart.cliente);
    datiRord.agente = Number(agente.code);
    datiRord.dataconsegna = ' ';
    if ((tipo === 'CD' || tipo === 'PCD') && cart.contoDepositoHasNoDays()) {
      datiRord.dataresa = 0;
    } else {
      datiRord.dataresa =
        cart.dataresa > 0 && (tipo === 'CD' || tipo === 'PCD')
          ? cart.dataresa
          : ' ';
    }
    datiRord.dataordine = Number(moment().format('YYYYMMDD'));
    datiRord.saldoordine = cart.asaldo ? 'S' : 'N';
    datiRord.ditta = 1;
    datiRord.magazzino = 1;
    datiRord.pagamento = cart.modpag;
    datiRord.riferimentocliente = cart.riferimentocliente;
    datiRord.datariferimentocliente = cart.datariferimentocliente
      ? Number(moment(cart.datariferimentocliente).format('YYYYMMDD'))
      : ' ';
    datiRord.evasionedal = cart.evasionedal
      ? Number(moment(cart.evasionedal).format('YYYYMMDD'))
      : ' ';
    datiRord.evadibileintegralmente = cart.evadibileintegralmente ? 'S' : 'N';
    datiRord.annotazionetesta = cart.annotazionetesta
      ? cart.annotazionetesta
      : ' ';
    datiRord.tipocarrello = tipo;
    const elencoOrdini = [];
    righe.forEach((item) => {
      const sconto = item.sconto ? Number(Number(item.sconto).toFixed(2)) : 0;
      if (item.contoDeposito && item.qtaContoDeposito > 0) {
      }
      if (item.qtaOmaggio && Number(item.qtaOmaggio) > 0) {
        elencoOrdini.push({
          ean: Number(item.ean),
          qta: Number(item.qtaOmaggio),
          titolo: item.article.titolo,
          scontobase: sconto,
          sconto1: 0,
          sconto2: 0,
          sconto3: 0,
          omaggio: 'S',
          scontoaggiuntivo: sconto > 0 ? 'S' : 'N',
          annotazione: ' ',
        });
      }

      elencoOrdini.push({
        ean: Number(item.ean),
        qta: Number(item.qta),
        titolo: item.article.titolo,
        scontobase: sconto,
        sconto1: 0,
        sconto2: 0,
        sconto3: 0,
        omaggio: 'N',
        scontoaggiuntivo: sconto > 0 ? 'S' : 'N',
        annotazione: ' ',
      });
    });
    datiRord.elencoArticoli = _.orderBy(elencoOrdini, ['ean', 'omaggio']);

    datiRord.numerorighe = datiRord.elencoArticoli.length;
    this.datiRord = datiRord;
    return this;
  }
}

export class cart implements cart {
  constructor(righe = [], cliente = '', intestazione = '', closed = false) {
    this.closed = closed;
    this.righe = righe;
    this.cliente = cliente;
    this.cliente_intestazione = intestazione;
    this.data = new Date();
    this.setupRighe();
  }
  /*
  public getRowsOrderToSend() {
    const orderRows = {rows : [], header : {}};
    orderRows.header = {
      resa : (this.dataresa) ? (this.dataresa) : 0,
      pagamento : this.modpag,
      conto: this.cliente,
      data: moment(this.data).format('YYYYMMDD')
    };
    this.righe.forEach((item: cartItem) => {
      orderRows.rows.push(
        {
          ean: item.ean,
          titolo: item.article.titolo,
          quantita: item.qta,
          omaggio: item.qtaOmaggio,
          prezzo: item.prezzo,
          sconto: item.sconto,
          deposito: item.contoDeposito,
          stato : item.article.stato
        });
    });
    return orderRows;
  }
*/
  assign(cart: cart): void {
    Object.assign(this, cart);
  }

  setDataResa(data: number) {
    this.dataresa = data;
  }

  public setCliente(cliente: clienteBE) {
    this.cliente = cliente.conto;
    this.cliente_intestazione = cliente.ragione_sociale;
    if (cliente.mod_pag && Number(cliente.mod_pag) > 0) {
      this.modpag = Number(cliente.mod_pag);
    }
  }

  public setModPag(modpag) {
    this.modpag = Number(modpag);
  }

  public addArticle(cartItem: cartItem) {
    const index = _.findIndex(this.righe, { ean: cartItem.ean });
    if (index > -1) {
      this.righe[index] = cartItem;
    } else {
      this.righe.push(cartItem);
    }
  }

  public deleteArticle(code) {
    const index = _.findIndex(this.righe, { ean: code });
    if (index > -1) {
      this.righe.splice(index, 1);
    }
  }

  public totale() {
    let totale = 0;
    this.righe.forEach((riga) => {
      totale += Number(riga.article.prezzo) * Number(riga.qta);
    });
    return totale;
  }

  public totalePezzi() {
    let totale = 0;
    this.righe.forEach((riga) => {
      totale = totale + Number(riga.qta);
    });
    return totale;
  }

  public scontoTot() {
    return this.righe
      .map((el) => this.nettoRiga(el))
      .reduce((total, next) => total + next);
  }

  public nettoRiga(c: cartItem) {
    let netto = c.prezzo - c.prezzo * (this.getScontoCliente() / 100);
    netto -= netto * (c.sconto / 100);

    return netto * c.qta;
  }

  public getTotSconot() {
    //tot : 100 = x : (lordo - netto)
    return (((this.totale() - this.scontoTot()) * 100) / this.totale()).toFixed(
      2,
    );
  }

  public scontoMedio() {
    return this.righe.length
      ? this.righe
          .map((item) => {
            item.sconto = Number(item.sconto);
            return item;
          })
          .reduce((total, next) => total + next.sconto, 0) / this.righe.length
      : 0;
  }

  public totaleOmaggi() {
    let totale = 0;
    this.righe.forEach((riga) => {
      if (riga.qtaOmaggio) {
        totale = totale + Number(riga.qtaOmaggio);
      }
    });
    return totale;
  }

  public qta(article: articoloBE): number {
    const index = _.findIndex(this.righe, { ean: article.ean });
    if (index > -1) {
      return this.righe[index].qta;
    }
    return 0;
  }

  public contoDepositoHasNoDays(): boolean {
    if (this.cliente) {
      const cliente = JSON.parse(localStorage.getItem('cliente'));
      const depositoInfo = contoDepositoInfo(cliente.dep_ass);
      if (Number(depositoInfo.code) > 7) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  public hasResa(): boolean {
    let resa = false;
    this.righe.forEach((item: cartItem) => {
      if (item.contoDeposito) {
        resa = true;
      }
    });
    return resa;
  }

  private setupRighe() {
    this.righe.forEach((item: cartItem) => {
      if (!item.qtaOmaggio) {
        item.qtaOmaggio = 0;
      }
      if (!item.sconto) {
        item.sconto = 0;
      }
    });
  }

  public getScontoCliente() {
    return this.righe[0].scontoCliente;
  }
}
